<template>
  <top-bar></top-bar>
  
  <main>
    <transition name="fade">
    <game-profits v-if="isProfitViewActive"></game-profits>
    <gamer-salary v-else></gamer-salary>
    </transition>
  </main>
  
</template>

<script>
import GameProfits from "@/pages/GameProfits";
import GamerSalary from "@/pages/GamerSalary";
import TopBar from '@/components/Shared/TopBar';

export default {
  components: {
    GameProfits,
    GamerSalary,
    TopBar,
  },
  computed: {
    isProfitViewActive() {
      return this.$store.getters.isProfitViewActive;
    },
  },
  mounted() {
    setInterval(() => this.$store.commit("increaseTimer"), 1000);
  },
};
</script>


    GameProfits<style lang="scss" scoped>
main {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding:0px 20px 0px 20px;
}

section {
  max-width: 1200px;
  width:100%;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}

.fade-enter-to {
  opacity: 1;
  transform: translate(0);
}
.fade-enter-active {
  transition: all 0.8s ease-out;
}

  
</style>